module.exports = __webpack_public_path__ + "media/images/front/team/carlos_robles-60879d96016a06ce6c6606ef51b85d46.jpg";